import { createAsyncThunk } from '@reduxjs/toolkit'
import { AppDispatch, RootState } from '@/redux/store'
import WebSocketManager from '@/services/websocketManager'
import { setLoadingMoreMessages } from '@/redux/slices/teamChatSlice'

const wsManager = WebSocketManager.getInstance()

export const connectTeamChatWebSocket = createAsyncThunk<
  void,
  {
    jwtToken: string
    roomId: string
    phaseId?: string
    teamId?: string
    impersonatePlayerId?: string
  },
  { dispatch: AppDispatch; state: RootState }
>(
  'websocket/connectTeamChat',
  async (
    { jwtToken, roomId, teamId, phaseId, impersonatePlayerId },
    { rejectWithValue }
  ) => {
    try {
      return await wsManager.connectToTeamChat(
        jwtToken,
        roomId,
        teamId,
        phaseId,
        impersonatePlayerId
      )
    } catch (error) {
      return rejectWithValue(
        (error as Error).message || 'Failed to connect to team chat websocket'
      )
    }
  }
)

export const disconnectTeamChatWebSocket = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch }
>('websocket/disconnectTeamChat', async () => {
  return await wsManager.disconnect('team_chat')
})

export const sendTeamChatMessage = createAsyncThunk<
  void,
  { message: string },
  { dispatch: AppDispatch; state: RootState }
>('websocket/sendTeamChatMessage', async ({ message }, { rejectWithValue }) => {
  console.log('send team message')
  const success = wsManager.sendMessage('team_chat', {
    type: 'SEND_TEAM_MESSAGE',
    message,
  })

  if (!success) {
    return rejectWithValue('WebSocket is not connected')
  }
})

export const loadTeamChatMessages = createAsyncThunk<
  void,
  void,
  { dispatch: AppDispatch; state: RootState }
>('websocket/loadTeamChatMessages', async (_, { rejectWithValue }) => {
  const success = wsManager.sendMessage('team_chat', {
    type: 'LOAD_TEAM_MESSAGES',
  })

  if (!success) {
    return rejectWithValue('WebSocket is not connected')
  }
})

export const loadMoreTeamChatMessages = createAsyncThunk<
  void,
  { page: number; pageSize?: number },
  { dispatch: AppDispatch; state: RootState }
>(
  'websocket/loadMoreTeamChatMessages',
  async ({ page, pageSize = 20 }, { dispatch, rejectWithValue }) => {
    dispatch(setLoadingMoreMessages(true))

    const success = wsManager.sendMessage('team_chat', {
      type: 'LOAD_MORE_TEAM_MESSAGES',
      page,
      page_size: pageSize,
    })

    if (!success) {
      dispatch(setLoadingMoreMessages(false))
      return rejectWithValue('WebSocket is not connected')
    }
  }
)
